import "./ObjectsTable.css";
import React, {ReactNode, useState} from "react";

export interface RenderRowOptions {
    isSelected: boolean;
    isHovered: boolean;
}

export interface ObjectsTableProps<T> {
    items: T[];
    getKey: (item: T) => string | number;
    selectedKey?: string | number | null;
    onRowClick?: (item: T) => void;
    renderRow: (item: T, options: RenderRowOptions) => ReactNode;
    header?: ReactNode;
}

export function ObjectsTable<T>(props: ObjectsTableProps<T>) {
    const {
        items,
        getKey,
        selectedKey,
        onRowClick,
        renderRow,
        header,
    } = props;

    const [hoveredKey, setHoveredKey] = useState<string | number | null>(null);

    return (
        <div className="objectstable">
            {header &&
                <div className="objectstable-header">{header}</div>
            }
            <div className="objectstable-list">
                {items.map((item) => {
                    const key = getKey(item);
                    const isSelected = key === selectedKey;
                    const isHovered = key === hoveredKey;
                    const handleClick = () => onRowClick?.(item);

                    return (
                        <div key={key}
                             className="objectstable-row"
                             onClick={handleClick}
                             onMouseEnter={() => setHoveredKey(key)}
                             onMouseLeave={() => setHoveredKey(null)}
                        >
                            {renderRow(item, {isSelected, isHovered})}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
